<ng-container>
    <div class="checkboxes-modal-empty">
        <div mat-dialog-title>
            <h2 *ngIf="data.type == 1">{{"content3.Menu Items" | translate}}</h2>
            <h2 *ngIf="data.type == 2">{{"restaurant.Staff Members" | translate}}</h2>
            <button mat-icon-button mat-dialog-close class="close">
                <mat-icon class="pop-close">close</mat-icon>
            </button>
        </div>
        <div *ngIf='dataLoading' class="dataLoading">
          <mat-spinner class="m-auto" diameter="50"></mat-spinner>
      </div>
        <mat-dialog-content class="pt-1 checkboxes-modal p-0" *ngIf='!dataLoading'>
            <div class="mat-dialog-body">
                <div *ngIf="items.length || members.length; else dataEmpty">
                    <div class="table-responsive">
                        <table class="table table-primary">
                            <thead>
                                <th>
                                    <ng-container *ngIf="data.type == 1">
                                        {{"stockManagement.Item" | translate}}
                                    </ng-container>
                                    <ng-container *ngIf="data.type == 2">
                                        {{"content4.Member" | translate}}
                                    </ng-container>
                                </th>
                            </thead>
                            <tbody >
                                <ng-container *ngIf="data.type == 1">
                                    <tr *ngFor="let item of items">
                                        <td>
                                            <div class="name-with-image squared">
                                                <div class="image-circle">
                                                    <span *ngIf="!item.icon && lang == 'en'">{{ item.itemNameEn | shortName }}</span>
                                                    <span *ngIf="!item.icon && lang == 'ar'">{{ item.itemNameAr | shortName }}</span>
                                                    <img *ngIf="item.icon" [src]="item.icon" (error)="item.icon = ''">
                                                </div>
                                                <div class="name">
                                                    <h5 class="font-16">{{item.itemNameEn}}</h5>
                                                    <h5 class="font-16">{{item.itemNameAr}}</h5>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                                <ng-container *ngIf="data.type == 2">
                                    <tr *ngFor="let member of members">
                                        <td>
                                            <div class="name-with-image squared">
                                                <div class="image-circle">
                                                    <span *ngIf="!member.icon">{{ member.name | shortName }}</span>
                                                    <img *ngIf="member.icon" [src]="member.icon" (error)="member.icon = ''">
                                                </div>
                                                <div class="name">
                                                    <h5 class="font-16">{{member.name}}</h5>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button mat-button mat-dialog-close class="btn-grey">{{"forms.Cancel" | translate}}</button>
        </mat-dialog-actions>

        <ng-template #dataEmpty>
            <empty-state [title]='"general.No Data Found" | translate'></empty-state>
        </ng-template>
    </div>
</ng-container>
